import { Button } from "@/shared/components/ui/button";
import { Link } from "react-router-dom";

export function Hero() {
  return (
    <section
      className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center overflow-hidden bg-fixed md:bg-fixed touch-device-bg-scroll"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80')",
      }}
    >
      {/* Gradient overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white animate-in fade-in duration-1000">
        {/* Experience badge */}
        <div className="inline-flex items-center gap-2 bg-amber-900/40 backdrop-blur-md rounded-full px-5 py-2.5 mb-8 border border-amber-400/30 shadow-lg animate-smooth-fade-in hover-glow">
          <div className="w-2.5 h-2.5 bg-amber-400 rounded-full animate-pulse-glow"></div>
          <span className="text-sm font-semibold tracking-wide text-amber-100">25+ Years of Excellence</span>
        </div>

        {/* Main heading */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 animate-smooth-slide-up will-animate" style={{ animationDelay: '200ms' }}>
          <span className="text-amber-50 drop-shadow-2xl">Discover Your</span>
          <br />
          <span className="autumn-text-gradient drop-shadow-2xl">Dream Journey</span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-lg animate-in slide-in-from-bottom duration-700" style={{ animationDelay: '400ms' }}>
          Experience extraordinary adventures with our curated travel packages.
          From exotic destinations to cultural immersions, we make your travel
          dreams come true.
        </p>

        {/* CTA Button */}
        <div className="animate-in slide-in-from-bottom duration-700" style={{ animationDelay: '600ms' }}>
          <Button
            asChild
            variant="ghost"
            className="btn-autumn-primary px-10 py-6 text-lg font-semibold rounded-full shadow-2xl hover:shadow-amber-500/50 transform hover:scale-105 transition-[transform,shadow] duration-300"
            style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)', color: 'white' }}
            onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.currentTarget.style.backgroundColor = 'rgb(234 88 12)'
              e.currentTarget.style.color = 'white'
            }}
            onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.currentTarget.style.backgroundColor = 'rgb(249 115 22)'
              e.currentTarget.style.color = 'white'
            }}
          >
            <Link to="/destination">
              Explore Destinations →
            </Link>
          </Button>
        </div>
      </div>
      <div id="data-scroll-section" data-scroll-section></div>
    </section>
  );
}
